module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_chevron_left-4619449a059472de2cf82f8776e3acd6.svg";